import * as THREE from 'three'

/** scene内で共有されるgeometry/material/textureを一度ずつ解放する。 */
export const disposeVrmScene = (scene: THREE.Object3D): void => {
  const geometries = new Set<THREE.BufferGeometry>()
  const materials = new Set<THREE.Material>()
  const textures = new Set<THREE.Texture>()
  const skeletons = new Set<THREE.Skeleton>()
  scene.visible = false
  scene.removeFromParent()
  scene.traverse((object) => {
    if (!(object instanceof THREE.Mesh)) return
    geometries.add(object.geometry)
    for (const material of Array.isArray(object.material) ? object.material : [object.material]) {
      materials.add(material)
    }
    if (object instanceof THREE.SkinnedMesh) skeletons.add(object.skeleton)
  })
  for (const material of materials) {
    for (const value of Object.values(material)) {
      if (value instanceof THREE.Texture) textures.add(value)
    }
    if (material instanceof THREE.ShaderMaterial) {
      for (const uniform of Object.values(material.uniforms)) {
        if (uniform.value instanceof THREE.Texture) textures.add(uniform.value)
      }
    }
  }
  for (const skeleton of skeletons) {
    if (skeleton.boneTexture) textures.delete(skeleton.boneTexture)
    skeleton.dispose()
  }
  for (const texture of textures) texture.dispose()
  for (const material of materials) material.dispose()
  for (const geometry of geometries) geometry.dispose()
}
